{
  "source": "legacy/cdm2026_v2.html",
  "r32Sources": {
    "M73": [
      "2A",
      "2B"
    ],
    "M74": [
      "1E",
      "3:M74"
    ],
    "M75": [
      "1F",
      "2C"
    ],
    "M76": [
      "1C",
      "2F"
    ],
    "M77": [
      "1I",
      "3:M77"
    ],
    "M78": [
      "2E",
      "2I"
    ],
    "M79": [
      "1A",
      "3:M79"
    ],
    "M80": [
      "1L",
      "3:M80"
    ],
    "M81": [
      "1D",
      "3:M81"
    ],
    "M82": [
      "1G",
      "3:M82"
    ],
    "M83": [
      "2K",
      "2L"
    ],
    "M84": [
      "1H",
      "2J"
    ],
    "M85": [
      "1B",
      "3:M85"
    ],
    "M86": [
      "1J",
      "2H"
    ],
    "M87": [
      "1K",
      "3:M87"
    ],
    "M88": [
      "2D",
      "2G"
    ]
  },
  "thirdsAllowedGroups": {
    "M74": [
      "A",
      "B",
      "C",
      "D",
      "F"
    ],
    "M77": [
      "C",
      "D",
      "F",
      "G",
      "H"
    ],
    "M79": [
      "C",
      "E",
      "F",
      "H",
      "I"
    ],
    "M80": [
      "E",
      "H",
      "I",
      "J",
      "K"
    ],
    "M81": [
      "B",
      "E",
      "F",
      "I",
      "J"
    ],
    "M82": [
      "A",
      "E",
      "H",
      "I",
      "J"
    ],
    "M85": [
      "E",
      "F",
      "G",
      "I",
      "J"
    ],
    "M87": [
      "D",
      "E",
      "I",
      "J",
      "L"
    ]
  },
  "thirdsSlotOrder": [
    "M74",
    "M77",
    "M79",
    "M80",
    "M81",
    "M82",
    "M85",
    "M87"
  ],
  "nodes": {
    "M73": {
      "round": "r32",
      "city": "Los Angeles",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "winnerTo": [
        "M90",
        "a"
      ],
      "loserTo": null
    },
    "M74": {
      "round": "r32",
      "city": "Boston",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M89",
        "a"
      ],
      "loserTo": null
    },
    "M75": {
      "round": "r32",
      "city": "Monterrey",
      "stadium": "Estadio BBVA",
      "stadiumFifa": "Estadio Monterrey",
      "hostCountry": "mx",
      "timezone": "America/Monterrey",
      "winnerTo": [
        "M90",
        "b"
      ],
      "loserTo": null
    },
    "M76": {
      "round": "r32",
      "city": "Houston",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M91",
        "a"
      ],
      "loserTo": null
    },
    "M77": {
      "round": "r32",
      "city": "New York–NJ",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M89",
        "b"
      ],
      "loserTo": null
    },
    "M78": {
      "round": "r32",
      "city": "Dallas",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M91",
        "b"
      ],
      "loserTo": null
    },
    "M79": {
      "round": "r32",
      "city": "Mexico",
      "stadium": "Estadio Azteca",
      "stadiumFifa": "Estadio Ciudad de México",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "winnerTo": [
        "M92",
        "a"
      ],
      "loserTo": null
    },
    "M80": {
      "round": "r32",
      "city": "Atlanta",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M92",
        "b"
      ],
      "loserTo": null
    },
    "M81": {
      "round": "r32",
      "city": "San Francisco",
      "stadium": "Levi's Stadium",
      "stadiumFifa": "San Francisco Bay Area Stadium",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "winnerTo": [
        "M94",
        "a"
      ],
      "loserTo": null
    },
    "M82": {
      "round": "r32",
      "city": "Seattle",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "winnerTo": [
        "M94",
        "b"
      ],
      "loserTo": null
    },
    "M83": {
      "round": "r32",
      "city": "Toronto",
      "stadium": "BMO Field",
      "stadiumFifa": "Toronto Stadium",
      "hostCountry": "ca",
      "timezone": "America/Toronto",
      "winnerTo": [
        "M93",
        "a"
      ],
      "loserTo": null
    },
    "M84": {
      "round": "r32",
      "city": "Los Angeles",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "winnerTo": [
        "M93",
        "b"
      ],
      "loserTo": null
    },
    "M85": {
      "round": "r32",
      "city": "Vancouver",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "winnerTo": [
        "M96",
        "a"
      ],
      "loserTo": null
    },
    "M86": {
      "round": "r32",
      "city": "Miami",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M95",
        "a"
      ],
      "loserTo": null
    },
    "M87": {
      "round": "r32",
      "city": "Kansas City",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M96",
        "b"
      ],
      "loserTo": null
    },
    "M88": {
      "round": "r32",
      "city": "Dallas",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M95",
        "b"
      ],
      "loserTo": null
    },
    "M89": {
      "round": "r16",
      "city": "Philadelphie",
      "stadium": "Lincoln Financial Field",
      "stadiumFifa": "Philadelphia Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M97",
        "a"
      ],
      "loserTo": null
    },
    "M90": {
      "round": "r16",
      "city": "Houston",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M97",
        "b"
      ],
      "loserTo": null
    },
    "M91": {
      "round": "r16",
      "city": "New York–NJ",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M99",
        "a"
      ],
      "loserTo": null
    },
    "M92": {
      "round": "r16",
      "city": "Mexico",
      "stadium": "Estadio Azteca",
      "stadiumFifa": "Estadio Ciudad de México",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "winnerTo": [
        "M99",
        "b"
      ],
      "loserTo": null
    },
    "M93": {
      "round": "r16",
      "city": "Dallas",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M98",
        "a"
      ],
      "loserTo": null
    },
    "M94": {
      "round": "r16",
      "city": "Seattle",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "winnerTo": [
        "M98",
        "b"
      ],
      "loserTo": null
    },
    "M95": {
      "round": "r16",
      "city": "Atlanta",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M100",
        "a"
      ],
      "loserTo": null
    },
    "M96": {
      "round": "r16",
      "city": "Vancouver",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "winnerTo": [
        "M100",
        "b"
      ],
      "loserTo": null
    },
    "M97": {
      "round": "qf",
      "city": "Boston",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M101",
        "a"
      ],
      "loserTo": null
    },
    "M98": {
      "round": "qf",
      "city": "Los Angeles",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "winnerTo": [
        "M101",
        "b"
      ],
      "loserTo": null
    },
    "M99": {
      "round": "qf",
      "city": "Miami",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M102",
        "a"
      ],
      "loserTo": null
    },
    "M100": {
      "round": "qf",
      "city": "Kansas City",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M102",
        "b"
      ],
      "loserTo": null
    },
    "M101": {
      "round": "sf",
      "city": "Dallas",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "winnerTo": [
        "M104",
        "a"
      ],
      "loserTo": [
        "M103",
        "a"
      ]
    },
    "M102": {
      "round": "sf",
      "city": "Atlanta",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": [
        "M104",
        "b"
      ],
      "loserTo": [
        "M103",
        "b"
      ]
    },
    "M103": {
      "round": "third",
      "city": "Miami",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": null,
      "loserTo": null
    },
    "M104": {
      "round": "final",
      "city": "New York–NJ",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "winnerTo": null,
      "loserTo": null
    }
  },
  "layout": {
    "columns": [
      [
        "M74",
        "M77",
        "M73",
        "M75",
        "M83",
        "M84",
        "M81",
        "M82"
      ],
      [
        "M89",
        "M90",
        "M93",
        "M94"
      ],
      [
        "M97",
        "M98"
      ],
      [
        "M101"
      ],
      "C",
      [
        "M102"
      ],
      [
        "M99",
        "M100"
      ],
      [
        "M91",
        "M92",
        "M95",
        "M96"
      ],
      [
        "M76",
        "M78",
        "M79",
        "M80",
        "M86",
        "M88",
        "M85",
        "M87"
      ]
    ],
    "labels": [
      "16es",
      "8es",
      "Quarts",
      "Demi",
      "Finale",
      "Demi",
      "Quarts",
      "8es",
      "16es"
    ],
    "designWidth": 1150
  }
}
